const ENDPOINT = '/api/beacon';
const GAME = 'brick-breaker';

function post(type: string, durationMs?: number): void {
  const payload: Record<string, unknown> = { game: GAME, type };
  if (durationMs !== undefined) payload.durationMs = Math.round(durationMs);
  const body = JSON.stringify(payload);
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }));
      return;
    }
    void fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {
      /* a lost counter is not worth surfacing */
    });
  } catch {
    /* ignore */
  }
}

export function reportPlay(): void {
  post('brick_play');
}

export function reportGameOver(durationMs: number): void {
  post('brick_game_over', durationMs);
}
